<template>
    <svg aria-hidden="true" focusable="false" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="12" fill="#9D9FA2" />
        <path d="M7.24268 16.576L16.3946 7.42404" stroke="black" stroke-linecap="round" />
        <path d="M16.3945 16.576L7.24258 7.42404" stroke="black" stroke-linecap="round" />
    </svg>
</template>
